import { createContext, type ReactNode } from "react";

/** The sidebar section the current page belongs to (its icon heads the page title, the way the familiar admin does). */
export const SectionContext = createContext<{ icon: () => ReactNode; label: string } | null>(null);
